export const LOGIND_DETAIL = "LOGIND_DETAIL";
export const PROFILE_CHECK = "PROFILE_CHECK";
export const DOCTOR_DETAIL = "DOCTOR_DETAIL";
export const SET_PATIENT_PROFILE = "SET_PATIENT_PROFILE";
export const SET_PATIENT_LOGIN = "SET_PATIENT_LOGIN";
export const SET_PATIENT_LOGOUT = "SET_PATIENT_LOGOUT";
